import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between" }
const _hoisted_2 = { class: "text-16px font-semibold" }
const _hoisted_3 = { class: "flex flex-row gap-x-2" }
const _hoisted_4 = { class: "w-400px" }
const _hoisted_5 = { class: "overflow-auto h-full" }
const _hoisted_6 = { class: "flex flex-row justify-between" }
const _hoisted_7 = { class: "text-16px font-semibold" }
const _hoisted_8 = { class: "flex flex-row gap-x-2" }
const _hoisted_9 = { class: "w-400px" }
const _hoisted_10 = { class: "overflow-auto h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_Search = _resolveComponent("Search")!
  const _component_TableV2 = _resolveComponent("TableV2")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("dexAssessmentDashboard.listAgentCsL1")), 1),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_CustomDropdown, {
            selectedItem: _ctx.filter.sortListCsL1,
            options: _ctx.sortListCsL1Data,
            placeholder: _ctx.$t('dexAssessmentDashboard.sortOrder'),
            onSelect: _ctx.selectSortListCsL1
          }, null, 8, ["selectedItem", "options", "placeholder", "onSelect"]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_Search, {
              onInput: val => _ctx.onSearch(val, 'l1'),
              onClear: () => _ctx.onSearch('', 'l1'),
              value: _ctx.filter.searchCsL1,
              placeholder: _ctx.$t('dexAssessmentDashboard.searchCsName')
            }, null, 8, ["onInput", "onClear", "value", "placeholder"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_TableV2, {
          loading: _ctx.isLoadingL1,
          borderTop: false,
          borderBottom: false,
          columns: _ctx.columns,
          data: _ctx.listDataCsL1,
          isEmpty: !_ctx.listDataCsL1.length,
          emptyHeaderMessage: _ctx.$t('dexAssessmentDashboard.emptyListAgentCsL1'),
          class: "my-2",
          onRequest: _ctx.fetchListCsL1,
          onTryAgain: _ctx.fetchListCsL1,
          hidePagination: true
        }, null, 8, ["loading", "columns", "data", "isEmpty", "emptyHeaderMessage", "onRequest", "onTryAgain"])
      ])
    ]),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("dexAssessmentDashboard.listAgentCsL2")), 1),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_CustomDropdown, {
            selectedItem: _ctx.filter.sortListCsL2,
            options: _ctx.sortListCsL1Data,
            placeholder: _ctx.$t('dexAssessmentDashboard.sortOrder'),
            onSelect: _ctx.selectSortListCsL2
          }, null, 8, ["selectedItem", "options", "placeholder", "onSelect"]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_Search, {
              onInput: val => _ctx.onSearch(val, 'l2'),
              onClear: () => _ctx.onSearch('', 'l2'),
              value: _ctx.filter.searchCsL2,
              placeholder: _ctx.$t('dexAssessmentDashboard.searchCsName')
            }, null, 8, ["onInput", "onClear", "value", "placeholder"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_TableV2, {
          loading: _ctx.isLoadingL2,
          borderTop: false,
          borderBottom: false,
          columns: _ctx.columns,
          data: _ctx.listDataCsL2,
          isEmpty: !_ctx.listDataCsL2.length,
          emptyHeaderMessage: _ctx.$t('dexAssessmentDashboard.emptyListAgentCsL2'),
          class: "my-2",
          onRequest: _ctx.fetchListCsL2,
          onTryAgain: _ctx.fetchListCsL2,
          hidePagination: true
        }, null, 8, ["loading", "columns", "data", "isEmpty", "emptyHeaderMessage", "onRequest", "onTryAgain"])
      ])
    ])
  ], 64))
}